import React from "react";
import { Leaf, IndianRupeeIcon, Smile } from "lucide-react";
import BestServiceImg from '../../img/bestService-img.png'

const BestServices = () => {
    return (
        <section className="best-services-section">
            <div className="best-services-container">
                <div className="best-services-content">
                    <h2 className="best-services-title">Why We Are The Best</h2>
                    <p className="best-services-description">
                        With more than 10 years of experience, we ensure you get the highest quality service and customer satisfaction. Here's why we stand out:
                    </p>
                    <div className="best-services-benefits">
                        <div className="benefit">
                            <div className="benefits-icon-title">
                                <Leaf size={24} color="#f38321" />
                                <h3>Eco-friendly Treatments</h3>
                            </div>
                            <p>We use best in class, environmentally safe active ingredients for effective pest control.</p>
                        </div>
                        <div className="benefit">
                            <div className="benefits-icon-title">
                                <IndianRupeeIcon size={24} color="#f38321" />
                                <h3>Cost Effective</h3>
                            </div>
                            <p>We offer competitive prices without compromising on quality of service.</p>
                        </div>
                        <div className="benefit">
                            <div className="benefits-icon-title">
                                <Smile size={24} color="#f38321" />
                                <h3>Customer Satisfaction</h3>
                            </div>
                            <p>We are committed to making sure you are happy with every service we provide.</p>
                        </div>
                    </div>
                </div>
                <div className="best-services-image">
                    <img
                        src={BestServiceImg} 
                        alt="Premium Service"
                        className="best-services-image-img"
                    />
                </div>
            </div>
        </section>
    );
};

export default BestServices;
